export const SEARCH_RESET = 'search/SEARCH_RESET'
export const SEARCH_INPUT_CLEAR = 'search/SEARCH_INPUT_CLEAR'
export const SEARCH_INPUT_CHANGED = 'search/SEARCH_INPUT_CHANGED'

export const SEARCH_SORT_CHANGED = 'search/SORT_CHANGED'

export const SEARCH_BROWSE_FILTER_ADDED = 'search/browse/FILTER_ADDED'
export const SEARCH_BROWSE_FILTER_REMOVED = 'search/browse/FILTER_REMOVED'
export const SEARCH_BROWSE_INIT = 'search/browse/INIT'
